import React from 'react'

export default function BillingPage() {
  return (
    <div>BillingPage</div>
  )
}
